import { Directive, HostListener, inject, Input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { normalizeNumericValue } from '../helpers/normalize-numeric.util';

@Directive({
  selector: '[normalizeNumeric]',
})
export class NormalizeNumericDirective {
  @Input() public normalizeEnabled = true;

  private readonly ngControl = inject(NgControl, { self: true, optional: true });

  private get control(): AbstractControl | null {
    return this.ngControl?.control ?? null;
  }

  @HostListener('blur')
  public onBlur(): void {
    if (!this.normalizeEnabled) {
      return;
    }

    this.normalizeControl();
  }

  private normalizeControl(): void {
    const control = this.control;
    if (!control) {
      return;
    }

    const raw = control.value;
    if (raw === null || raw === undefined || raw === '') {
      return;
    }

    const currentValue = Number(raw);
    if (!Number.isFinite(currentValue)) {
      return;
    }

    const normalized = normalizeNumericValue(currentValue);
    if (normalized === null) {
      return;
    }

    if (normalized !== currentValue) {
      control.setValue(normalized);
    }
  }
}
